// PWA service worker registration
export function registerSW() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  // Only register on production builds served over HTTPS or localhost
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const isSecure = window.location.protocol === 'https:' || isLocalhost;
  if (!isSecure) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => { /* noop */ });
  });
}
